<template>
    <div class="form-group">
        <div class="d-flex flex-row gap-2 justify-content-between align-items-center">
            <div>
                <label v-if="this.label" :for="this.idinput ?? null">{{ this.label ?? "" }}</label>
                <slot name="label-action"></slot>
            </div>
            <small>{{ this.hint ?? "" }}</small>
        </div>
        <p
            v-if="description"
            style="padding: 0!important; margin: 0;"
        >
            <small>{{ description || "" }}</small>
        </p>
        <slot></slot>
        <div class="invalid-feedback">
            {{ this.invalidmsg ?? '' }}
        </div>
    </div>
</template>
<style scoped>
    .form-group {
        position: relative;
        margin-bottom: 24px;
    }
    label {
        font-size: 15px;
        font-weight: 600;
        margin-bottom: 8px;
        display: block;
    }
</style>
<script>
export default {
    name: 'FormGroup',
    props: {
        label: String,
        hint: [String, Number],
        description: String,
        idinput: String,
        invalidmsg: String,
    }
}
</script>